import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

import { ApiService } from '../API/api.service';
import {
  DocumentContentDetails,
  DocumentDetails,
  GetDocumentByIdRequestPayload,
  GetDocumentContentByIdRequestPayload,
} from 'src/app/store/state/documents.state';
import { Record } from 'src/app/Layouts/admin-dashboard/food-safety-system/documents/document-details/models/records.model';

@Injectable({
  providedIn: 'root',
})
export class DocumentsService {
  constructor(public apiService: ApiService) {}

  private document = new BehaviorSubject({});

  currentEditDocument = this.document.asObservable();

  editDocumentData(data: any) {
    console.log(data);
    this.document.next(data);
  }
  getAllDocuments(body: any): Observable<any> {
    return this.apiService.post('document/getAllDocuments', body);
  }
  addDocuments(body: any): Observable<any> {
    return this.apiService.post('document/addDocument', body);
  }

  editDocuments(body: any, param: any): Observable<any> {
    return this.apiService.put('document/editDocument', param, body);
  }
  documentsType(body: any): Observable<any> {
    return this.apiService.get(
      'documentTypes/getDocumentTypes/' + body.company_id
    );
  }
  addDocumentsType(body: any): Observable<any> {
    return this.apiService.post('documentTypes/addDocumentType', body);
  }
  getTypeRecord(body: any): Observable<any> {
    return this.apiService.get(
      'documentTypes/getTypeRecord/' + body.company_id
    );
  }
  getDocumentsById(
    body: GetDocumentByIdRequestPayload
  ): Observable<DocumentDetails[]> {
    return this.apiService.get('document/getDocumentById/' + body.id);
  }

  getDocumentContentById(
    body: GetDocumentContentByIdRequestPayload
  ): Observable<DocumentContentDetails[]> {
    return this.apiService.post('document/geteditorContentById', body);
  }

  getDocumentCount(body: any): Observable<any> {
    return this.apiService.get('document/getDocumentCount/' + body.company_id);
  }
  getDocumentSearch(body: any, title: any): Observable<any> {
    return this.apiService.post(`document/getAllDocuments/${title}`, body);
  }
  downloadDocumentFile(body: any): Observable<any> {
    return this.apiService.post('file/downloadDocumentFile', body);
  }
  documentsName(body: any): Observable<any> {
    return this.apiService.get(
      'documentTypes/getDocumentTypes/' + body.company_id
    );
  }
  addDocumentsName(body: any): Observable<any> {
    return this.apiService.post('documentTypes/addDocumentType', body);
  }
  getDocumentImport(body: any): Observable<any> {
    return this.apiService.post('document/addDocument', body);
  }
  uploadDocuments(body: any): Observable<any> {
    return this.apiService.post('document/importDocuments', body);
  }
  deleteDocument(body: any): Observable<any> {
    return this.apiService.post('document/deleteDocument', body);
  }
  getAllRecords(params: { companyID: number }): Observable<Record[]> {
    return this.apiService.get(
      `document/getRecordAndSuppDocs/${params.companyID}`
    );
  }
  acknowledgeDocuments(params: { documentId: number}): Observable<any> {
    return this.apiService.post(
      `acknowledgeDocument`,
      {
        documentId: params.documentId
      }
    )
  }
}
